// Firebase Configuration for VinciKit
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

// Firebase configuration from environment variables
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'AIzaSyCZXxyI8ZLPb8gSHgLWJFHR6Jx7LrS_a8U',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'vincikit-bd9e1.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'vincikit-bd9e1',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'vincikit-bd9e1.appspot.com',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || ''
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Auth
export const auth = getAuth(app);

// Configure Google Auth Provider
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

export default app;
